import AkahuLogo from "@mixitone/icons/akahu-logo.svg";
import type { ReactNode } from "react";

type AkahuPoweredByProps = {
  className?: string;
  learnMoreHref?: string;
  /** Short relationship line shown next to the logo. */
  children?: ReactNode;
};

/**
 * Secondary Akahu disclosure for consumer-facing pay-by-bank surfaces.
 * Lead with the payment action elsewhere; use this for provider context + logo.
 */
const AkahuPoweredBy = ({
  className,
  learnMoreHref = "https://www.akahu.nz",
  children = "Akahu is New Zealand's open finance platform. MixItOne uses Akahu for one-off pay-by-bank payments and one-time account checks. MixItOne does not keep ongoing access to your bank.",
}: AkahuPoweredByProps) => {
  return (
    <div className={className ?? "flex items-start gap-3 text-xs text-gray-600"}>
      <AkahuLogo className="mt-0.5 h-7 w-6 shrink-0" aria-hidden />
      <div className="min-w-0 space-y-1">
        <p>{children}</p>
        <a
          href={learnMoreHref}
          target="_blank"
          rel="noreferrer"
          className="font-medium text-gray-800 underline underline-offset-2"
        >
          Learn more about Akahu
        </a>
      </div>
    </div>
  );
};

export { AkahuPoweredBy };
